var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBiggestMoversSentiment({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "235px",
    height: "125px",
    viewBox: "0 0 235 125",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8B5AB464-E470-4D24-9569-39584222E2CC") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 235,
    height: 125,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chat-Simplified-Widget---Style-Guide",
    transform: "translate(-43.000000, -2270.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#EEEEEE",
    x: 0,
    y: 0,
    width: 1463,
    height: 2535
  }), /*#__PURE__*/React.createElement("g", {
    id: "Widget/Data/Chat/Summary-Metrics-Copy-2",
    transform: "translate(43.000000, 2270.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Background",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 235,
    height: 125
  })), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 72.2446154,
    x2: 235,
    y2: 72.2446154,
    id: "Path-4",
    stroke: "#979797",
    opacity: 0.251767113
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 41.6646154,
    x2: 235,
    y2: 41.6646154,
    id: "Path-4",
    stroke: "#979797",
    opacity: 0.251767113
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 102.824615,
    x2: 235,
    y2: 102.824615,
    id: "Path-4",
    stroke: "#979797",
    opacity: 0.251767113
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(55.874000, 19.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#E5E6E5",
    points: "16 91.3301 11 3.3301 5 3.3301 0 91.3301"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.657,96.65675 C16.781,93.53275 16.781,88.46775 13.657,85.34375 C10.532,82.21875 5.468,82.21875 2.343,85.34375 C-0.781,88.46775 -0.781,93.53275 2.343,96.65675 C5.468,99.78175 10.532,99.78175 13.657,96.65675",
    id: "Fill-4",
    fill: "#992E65"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(1.000000, 84.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,7.96117778 C6.11177778,7.96117778 5.369,8.59973333 5.23288889,9.48017778 C5.20022222,9.69251111 5.34566667,9.89084444 5.558,9.92351111 C5.768,9.95462222 5.96866667,9.81073333 6.00133333,9.5984 C6.07833333,9.10062222 6.49833333,8.73895556 7,8.73895556 C7.50166667,8.73895556 7.92166667,9.10062222 7.99866667,9.5984 C8.03133333,9.81073333 8.22966667,9.95462222 8.442,9.92351111 C8.65433333,9.89084444 8.79977778,9.69251111 8.76711111,9.48017778 C8.631,8.59973333 7.88822222,7.96117778 7,7.96117778",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.88888889,5.44444444 C3.45955556,5.44444444 3.11111111,5.01511111 3.11111111,5.44444444 C3.11111111,5.87377778 3.45955556,6.22222222 3.88888889,6.22222222 C4.31822222,6.22222222 4.66666667,5.87377778 4.66666667,5.44444444 C4.66666667,5.01511111 4.31822222,5.44444444 3.88888889,5.44444444",
    id: "Fill-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1111111,5.44444444 C9.68177778,5.44444444 9.33333333,5.01511111 9.33333333,5.44444444 C9.33333333,5.87377778 9.68177778,6.22222222 10.1111111,6.22222222 C10.5404444,6.22222222 10.8888889,5.87377778 10.8888889,5.44444444 C10.8888889,5.01511111 10.5404444,5.44444444 10.1111111,5.44444444",
    id: "Fill-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,13.2222222 C3.56922222,13.2222222 0.777777778,10.4307778 0.777777778,7 C0.777777778,3.56922222 3.56922222,0.777777778 7,0.777777778 C10.4307778,0.777777778 13.2222222,3.56922222 13.2222222,7 C13.2222222,10.4307778 10.4307778,13.2222222 7,13.2222222 M7,0 C3.13366667,0 0,3.13366667 0,7 C0,10.8663333 3.13366667,14 7,14 C10.8663333,14 14,10.8663333 14,7 C14,3.13366667 10.8663333,0 7,0",
    id: "Fill-7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8,6 C9.657,6 11,4.657 11,3 C11,1.343 9.657,0 8,0 C6.343,0 5,1.343 5,3 C5,4.657 6.343,6 8,6",
    id: "Fill-6",
    fill: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(164.999900, 19.000150)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-18",
    fill: "#E5E6E5",
    points: "16 7.99995 11 72.99995 5 72.99995 0 7.99995"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,75.99995 C9.657,75.99995 11,74.65695 11,72.99995 C11,71.34295 9.657,69.99995 8,69.99995 C6.343,69.99995 5,71.34295 5,72.99995 C5,74.65695 6.343,75.99995 8,75.99995",
    id: "Fill-8",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6573,13.65675 C16.7813,10.53275 16.7813,5.46775 13.6573,2.34375 C10.5323,-0.78125 5.4673,-0.78125 2.3433,2.34375 C0.7813,3.90575 0.000300000001,5.95275 0.000300000001,7.99975 C0.000300000001,10.04775 0.7813,12.09475 2.3433,13.65675 C5.4673,16.78175 10.5323,16.78175 13.6573,13.65675",
    id: "Fill-1",
    fill: "#6BBE0B"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 11.0846154,
    x2: 235,
    y2: 11.0846154,
    id: "Path-4",
    stroke: "#979797",
    opacity: 0.251767113
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(166.000000, 20.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.442,7.96537778 C8.22966667,7.93426667 8.03133333,8.07893333 7.99866667,8.29048889 C7.92166667,8.78904444 7.50166667,9.14993333 7,9.14993333 C6.49833333,9.14993333 6.07833333,8.78904444 6.00133333,8.29048889 C5.96866667,8.07893333 5.768,7.93426667 5.558,7.96537778 C5.34566667,7.99804444 5.20022222,8.19715556 5.23288889,8.40871111 C5.369,9.28915556 6.11177778,9.92771111 7,9.92771111 C7.88822222,9.92771111 8.631,9.28915556 8.76711111,8.40871111 C8.79977778,8.19715556 8.65433333,7.99804444 8.442,7.96537778",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.88888889,4.66666667 C3.45955556,4.66666667 3.11111111,5.01511111 3.11111111,5.44444444 C3.11111111,5.87377778 3.45955556,5.44444444 3.88888889,5.44444444 C4.31822222,5.44444444 4.66666667,5.87377778 4.66666667,5.44444444 C4.66666667,5.01511111 4.31822222,4.66666667 3.88888889,4.66666667",
    id: "Fill-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1111111,4.66666667 C9.68177778,4.66666667 9.33333333,5.01511111 9.33333333,5.44444444 C9.33333333,5.87377778 9.68177778,5.44444444 10.1111111,5.44444444 C10.5404444,5.44444444 10.8888889,5.87377778 10.8888889,5.44444444 C10.8888889,5.01511111 10.5404444,4.66666667 10.1111111,4.66666667",
    id: "Fill-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,13.2222222 C3.56922222,13.2222222 0.777777778,10.4307778 0.777777778,7 C0.777777778,3.56922222 3.56922222,0.777777778 7,0.777777778 C10.4307778,0.777777778 13.2222222,3.56922222 13.2222222,7 C13.2222222,10.4307778 10.4307778,13.2222222 7,13.2222222 M7,0 C3.13366667,0 0,3.13366667 0,7 C0,10.8663333 3.13366667,14 7,14 C10.8663333,14 14,10.8663333 14,7 C14,3.13366667 10.8663333,0 7,0",
    id: "Fill-7"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiggestMoversSentiment);
export default __webpack_public_path__ + "static/media/biggest-movers-sentiment.751a192a33af50dfa19372df8b552bfe.svg";
export { ForwardRef as ReactComponent };